import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { properties } from 'src/environments/properties';

@Component({
  selector: 'app-partners-error',
  templateUrl: './partners-error.component.html',
  styleUrls: ['./partners-error.component.scss']
})
export class PartnersErrorComponent {

  @Input() errorMessage: any;
  properties = properties;
  constructor(private router: Router) { }


  navigateToSubscribe() {
    this.router.navigate(['freshpass/manage/subscribe']);
  }

}
